import { Component, ElementRef, Input, OnInit, ViewChild, EventEmitter, Output, Renderer2 } from '@angular/core';
import { ExtendedKeyValuePair, IKeyValuePair } from '@app-shared/models/key-value-pair.model';
import { IProduct } from '@empf-shared/services/product/models/IProduct';
import { NgForm } from '@angular/forms';
import { BestEffortsDeliveryData } from '@origination-shared/services/delivery-commitment/models/inner/BestEffortsDeliveryData';
import { IDeliveryCommitment } from '@empf-shared/services/transaction/delivery-commitment/IDeliveryCommitment';
import { CustomToastService } from 'src/shared/services';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { BestEffortsDcRepriceModalComponent } from '../best-efforts-dc-reprice-modal/best-efforts-dc-reprice-modal.component';
import { GetPricingforExistingDCApiResponse } from '@origination-shared/services/delivery-commitment/models/GetPricingforExistingDCApiResponse';
import { IDeliveryCommitmentViewModel } from '@empf-shared/services/transaction/delivery-commitment/IDeliveryCommitmentViewModel';
import { GetBestEffortsDeliveryDataApiResponse } from '@origination-shared/services/delivery-commitment/models/GetBestEffortsDeliveryDataApiResponse';
import { UtilHelper } from '@app-shared/services';
import { Address } from '@app-shared/models/address-autocomplete.model';

@Component({
    selector: 'app-best-efforts-form',
    templateUrl: './best-efforts-form.component.html',
    styleUrls: ['./best-efforts-form.component.sass']
})
export class BestEffortsFormComponent implements OnInit {
    @Input() bestEffortsDeliveryData: GetBestEffortsDeliveryDataApiResponse;
    @Input() cmsModel: any;
    @Input() dcExistingModel: IDeliveryCommitmentViewModel;
    @Input() dcMainModel: any;
    @Input() propertyTypeOptions: ExtendedKeyValuePair[] = [];
    @Input() loanPurposesOptions: ExtendedKeyValuePair[] = [];
    @Input() occupancyOptions: ExtendedKeyValuePair[] = [];
    @Input() stateOptions: IKeyValuePair[];
    @Input() productsList: IProduct[];
    @Input() isFhlbcUser: boolean;
    @Input() isActiveAndUnfunded: boolean;
    @Output() cancelTradBEDC: EventEmitter<void> = new EventEmitter<void>();
    @Output() submitTradBEDC: EventEmitter<{ repriceChanged: boolean, dc: IDeliveryCommitment, be: BestEffortsDeliveryData }> = new EventEmitter<{ repriceChanged: boolean, dc: IDeliveryCommitment, be: BestEffortsDeliveryData }>();
    @Output() resetRepriceCheck: EventEmitter<void> = new EventEmitter<void>();


    @Input() pricingForDcApiResponse: GetPricingforExistingDCApiResponse;
    @Input() originalDeliveryCommitment: IDeliveryCommitment;
    @Input() set showRepriceModalOnSave(value: boolean) {
        if (value) {
            this.triggerRepriceModalOnSaveorSubmit();
        }
    }

    loanPurposeSelected: string;
    propertyTypeSelected: string;
    occupancySelected: string;
    productSelected: string;
    @ViewChild('besteffortsform', { static: true }) besteffortsform: NgForm;
    @Input() formSubmitted: boolean = false;
    @ViewChild('noteRateControl', { static: false }) noteRateControl: ElementRef;

    coBorrowers: any[] = [];
    validationErrors: Array<string>;
    private initialProductSelected: string;
    private initialSubProductSelected: string;
    filteredSubProducts: any[] = [];
    originalScheduleCode: string;
    selectedProductCode: string;
    noteRates: any[] = [];
    showRepriceBox: boolean = false;
    originalAgentFeeRate: number = 0;
    newAgentFeeRate: number = 0;
    originalBestEffortsData: any;
    bestEffortsValidated: boolean = false

    constructor(private toastr: CustomToastService, public renderer: Renderer2,
        private modalService: NgbModal) { }

    ngOnInit() {
        console.log('BestEffortsFormComponent initialized');
        const data: any = this.bestEffortsDeliveryData?.bestEffortsDeliveryData?.[0] ?? {};

        data.borrowerSSN = this.scrubSSN(data.borrowerSSN, this.isFhlbcUser);
        data.coBorrower1SSN = this.scrubSSN(data.coBorrower1SSN, this.isFhlbcUser);
        data.coBorrower2SSN = this.scrubSSN(data.coBorrower2SSN, this.isFhlbcUser);
        data.coBorrower3SSN = this.scrubSSN(data.coBorrower3SSN, this.isFhlbcUser);
        
        this.coBorrowers = [1, 2, 3].map(i => ({
            coBorrowerExists: false,
            firstName: data[`coBorrower${i}FirstName`] ?? null,
            middleInitial: data[`coBorrower${i}MiddleInitial`] ?? null,
            lastName: data[`coBorrower${i}LastName`] ?? null,
            ssn: data[`coBorrower${i}SSN`] ?? null,
            suffix: data[`coBorrower${i}Suffix`] ?? null
        }));

        this.coBorrowers.forEach((coBorr) => {
            if (coBorr.firstName || coBorr.lastName || coBorr.ssn)
            {
                coBorr.coBorrowerExists = true;
            }
        });

        const matchedProduct = this.productsList?.find(
            product => product.productCode === this.dcExistingModel.deliveryCommitment.productCode
        );
        this.productSelected = matchedProduct ? matchedProduct.productName : null;
        this.selectedProductCode = matchedProduct ? matchedProduct.productCode : null;

        this.originalBestEffortsData = JSON.parse(
            JSON.stringify(this.bestEffortsDeliveryData?.bestEffortsDeliveryData?.[0] ?? {})
        );
        const originalProductCode = this.dcExistingModel.deliveryCommitment.productCode;
        this.filteredSubProducts = this.getSubProductsByProductCode(originalProductCode);

        this.getPropertyTypeandLoanPurposeForDisplay();
        this.noteRates = this.getNoteRatesByTpmScheduleCode(this.dcExistingModel.deliveryCommitment.scheduleCode);
        this.initialProductSelected = this.productSelected;
        this.initialSubProductSelected = this.dcExistingModel.deliveryCommitment.subProductName;
        this.originalScheduleCode = this.dcExistingModel.deliveryCommitment.scheduleCode;

        this.selectNoteRate(this.dcExistingModel.deliveryCommitment.noteRate);
    }

    scrubSSN(ssn: string, isFhlbcUser: boolean): string 
    {
        if (UtilHelper.isDefinedOrNotNull(ssn) && ssn !== '')
        {
            let scrubbedSSN: string = '';
            if (isFhlbcUser)
            {
                scrubbedSSN = '00000' + ssn;
            }
            else
            {
                scrubbedSSN = 'XXX-XX-' + ssn;
            }
            
            return scrubbedSSN;
        }
        else
        {
            return ssn;
        }
    }

    getPropertyTypeandLoanPurposeForDisplay() {
        this.loanPurposeSelected = this.loanPurposesOptions?.find(item => item.value === this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].loanPurpose)?.name ?? null;
        this.propertyTypeSelected = this.propertyTypeOptions?.find(item => item.value === this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].propertyType)?.name ?? null;
        this.occupancySelected = this.occupancyOptions?.find(item => item.name === this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].occupancy)?.name ?? null;

        const matchedProduct = this.productsList?.find(
            product => product.productCode === this.dcExistingModel.deliveryCommitment.productCode
        );
        this.productSelected = matchedProduct ? matchedProduct.productName : null;
    }

    openRepriceModal() {
        const modalRef = this.modalService.open(BestEffortsDcRepriceModalComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.originalAgentFeeRate = this.originalAgentFeeRate;
        modalRef.componentInstance.newAgentFeeRate = this.newAgentFeeRate;
        modalRef.componentInstance.ShowRepriceBox = true;
        modalRef.result.then((result) => {
            if (result === 'proceed') {
                this.onRepriceYes();
            } else if (result === 'cancel-confirmed') {
                // Navigate to View Delivery Commitment screen
                this.onRepriceCancel();
            }
        });
    }
    getAgentFeeForCurrentSelection(): number {
        // Find the noteRate object for the selected note rate
        if (UtilHelper.isDefinedOrNotNull(this.dcExistingModel.deliveryCommitment.noteRate))
        {
            const noteRateObj = (this.noteRates || []).find(nr => nr.rate === this.dcExistingModel.deliveryCommitment.noteRate);
            return noteRateObj ? noteRateObj.agentFee : 0;
        }
        else
        {
            return this.dcExistingModel.deliveryCommitment.agentFee;
        }
    }
    // Called when Subproduct changes

    onSubProductChange(event: any) {
        this.noteRates = []; // Reset note rates
        this.dcExistingModel.deliveryCommitment.noteRate = null; // clear note rate selection
        this.resetRepriceCheck.emit(); // Reset reprice check flag for LOS Edit DC screen
        const subProductCode = this.dcExistingModel.deliveryCommitment.subProductCode;
        const selectedSubProduct = this.filteredSubProducts.find(sub => sub.subProductCode === subProductCode);
        if (selectedSubProduct) {
            this.dcExistingModel.deliveryCommitment.subProductCode = selectedSubProduct.subProductCode;
            this.dcExistingModel.deliveryCommitment.subProductId = selectedSubProduct.productId;
            this.dcExistingModel.deliveryCommitment.subProductName = selectedSubProduct.subProductName;
        }

        if (UtilHelper.isDefinedOrNotNull(subProductCode) && subProductCode !== '') {
            const commitmentTerm = this.dcExistingModel.deliveryCommitment.commitmentTerm;
            let hasPricing = false;
            for (const schedule of this.pricingForDcApiResponse.schedules) {
                for (const detail of schedule.scheduleDetail) {
                    if (detail.commitmentTerm && Array.isArray(detail.commitmentTerm) && detail.commitmentTerm.length > 0) {
                        for (const term of detail.commitmentTerm) {
                            if (
                                detail.subProductCode === subProductCode &&
                                detail.remittanceType === this.dcExistingModel.deliveryCommitment.remittanceType &&
                                term.numberOfDays === commitmentTerm &&
                                term.noteRate && term.noteRate.length > 0
                            ) {
                                hasPricing = true;
                                break;
                            }
                        }
                    }
                    if (hasPricing) break;
                }
                if (hasPricing) break;
            }

            if (!hasPricing) {
                this.toastr.showMessage(this.cmsModel?.OutsideDistrictSubProductsMsg);
            } else {
                const newScheduleCode = this.getNewScheduleCode(subProductCode, commitmentTerm);
                if (newScheduleCode) {
                    this.dcExistingModel.deliveryCommitment.scheduleCode = newScheduleCode;
                    this.noteRates = this.getNoteRatesByTpmScheduleCode(newScheduleCode); // <-- update noteRates
                }
            }
        }
    }

    openPopover(p: NgbPopover) {
        setTimeout(() => {
            p.open();
        }, 100);
    }

    selectNoteRate(selectedNoteRate) {
        this.dcExistingModel.deliveryCommitment.noteRate = selectedNoteRate;
        this.onNoteRateManualChange();
        setTimeout(() => {
            console.log((selectedNoteRate * 100).toFixed(3) + '%');
            this.renderer.setProperty(this.noteRateControl.nativeElement, "value", (selectedNoteRate * 100).toFixed(3) + '%');
        });

    }

    onNoteRateManualChange() {
        this.dcExistingModel.deliveryCommitment.agentFee = this.getAgentFeeForCurrentSelection();
        this.resetRepriceCheck.emit(); // Reset reprice check flag for LOS Edit DC screen
    }
    
    getSubProductsByProductCode(productCode: string): any[] {
        if (!this.pricingForDcApiResponse || !this.pricingForDcApiResponse.subProducts) {
            return [];
        }
        return this.pricingForDcApiResponse.subProducts.filter(
            sub => sub.productCode === productCode
        );
    }

    // If you want to update subproducts when product changes:
    onProductChange(event: any) {
        const subProductArray = {
            productId: 0,
            productCode: ' ',
            productName: ' '
        };
        this.toastr.remove();
        const selectedProduct = this.productsList.find(p => p.productName === this.productSelected);
        if (selectedProduct) {
            this.dcExistingModel.deliveryCommitment.productCode = selectedProduct.productCode; // <-- update model
            this.dcExistingModel.deliveryCommitment.productName = selectedProduct.productName;
            this.dcExistingModel.deliveryCommitment.product = this.dcExistingModel.deliveryCommitment.productName; // <-- update model
            this.productSelected = selectedProduct.productName;
            this.selectedProductCode = selectedProduct.productCode;
            this.filteredSubProducts = this.getSubProductsByProductCode(selectedProduct.productCode);
            if (this.filteredSubProducts !== null && this.filteredSubProducts.length > 0) {
                this.filteredSubProducts.splice(0, 0, subProductArray);
            }
            else {
                this.toastr.showMessage(this.cmsModel?.PricingUnavailableMsg);
            }

            this.dcExistingModel.deliveryCommitment.subProductCode = null; // clear subproduct selection
            this.dcExistingModel.deliveryCommitment.noteRate = null; // clear note rate selection
            this.resetRepriceCheck.emit(); // Reset reprice check flag for LOS Edit DC screen
            this.noteRates = [];
            this.initialProductSelected = this.productSelected;
        }
    }

    getNewScheduleCode(subProductCode: string, commitmentTerm: number): string | null {
        if (!this.pricingForDcApiResponse?.schedules) return null;

        // Use the correct product code
        const productCode = this.selectedProductCode;
        const remittanceType = this.dcExistingModel.deliveryCommitment.remittanceType;
        const originalTpmScheduleCode = this.originalScheduleCode;

        let originalScheduleSet = null;
        for (const schedule of this.pricingForDcApiResponse.schedules) {
            for (const detail of schedule.scheduleDetail) {
                if (detail.commitmentTerm && Array.isArray(detail.commitmentTerm) && detail.commitmentTerm.length > 0) {
                    for (const term of detail.commitmentTerm) {
                        if (term.tpmScheduleCode === originalTpmScheduleCode) {
                            originalScheduleSet = schedule;
                            break;
                        }
                    }
                }
                if (originalScheduleSet) break;
            }
            if (originalScheduleSet) break;
        }
        if (!originalScheduleSet) return null;

        for (const detail of originalScheduleSet.scheduleDetail) {
            if (
                detail.productCode === productCode &&
                detail.subProductCode === subProductCode &&
                detail.remittanceType === remittanceType
            ) {
                if (detail.commitmentTerm && Array.isArray(detail.commitmentTerm) && detail.commitmentTerm.length > 0) {
                    for (const term of detail.commitmentTerm) {
                        if (term.numberOfDays === commitmentTerm && term.deliveryType === 'B') {
                            return term.tpmScheduleCode;
                        }
                    }
                }
            }
        }
        return null;
    }

    getNoteRatesByTpmScheduleCode(tpmScheduleCode: string): any[] {
        if (!this.pricingForDcApiResponse?.schedules) return [];
        for (const schedule of this.pricingForDcApiResponse.schedules) {
            for (const detail of schedule.scheduleDetail) {
                if (detail.commitmentTerm && Array.isArray(detail.commitmentTerm) && detail.commitmentTerm.length > 0) {
                    for (const term of detail.commitmentTerm) {
                        if (term.tpmScheduleCode === tpmScheduleCode) {
                            // Sort noteRates in ascending order by rate
                            return (term.noteRate || []).sort((a, b) => a.rate - b.rate);
                        }
                    }
                }
            }
        }
        return [];
    }

    onRepriceYes() {
        this.showRepriceBox = false;
        this.formSubmitted = true;
        this.dcExistingModel.deliveryCommitment.noteRates = this.noteRates; // Update noteRates in the model
        this.dcExistingModel.deliveryCommitment.agentFee = this.getAgentFeeForCurrentSelection();
        this.submitTradBEDC.emit({
            repriceChanged: true,
            dc: this.dcExistingModel.deliveryCommitment,
            be: this.bestEffortsDeliveryData.bestEffortsDeliveryData[0]
        });
    }

    onRepriceCancel() {
        this.showRepriceBox = false;
        // Optionally show a cancel confirmation modal here
    }
    populateLTVAndTLTV() {
        if (this.dcExistingModel.deliveryCommitment.dcAmount.toString() === '') {
            this.dcExistingModel.deliveryCommitment.dcAmount = null;
        }

        // On LOS Edit DC screen, expired/closed DC's may still have their BE data updated. LTV/TLTV calculation should use DC amount at time of expiration, as DC amount will be reduced to $0 for an expired/closed DC
        var deliveryAmountToUse = this.dcExistingModel.deliveryCommitment.dcAmount;
        if (this.dcExistingModel.deliveryCommitment.deliveryStatus !== 'DC01')
        {
            deliveryAmountToUse = this.dcExistingModel.deliveryCommitment.deliveryAmountAtExpiration;
        }

        if (UtilHelper.isDefinedOrNotNull(deliveryAmountToUse) &&
            UtilHelper.isDefinedOrNotNull(this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].purchasePrice) &&
            UtilHelper.isDefinedOrNotNull(this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].subordinateFinancingAmount) &&
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].purchasePrice!= 0) 
        {
            const dcAmount = Number(deliveryAmountToUse);
            const appraisedValue = Number(this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].purchasePrice);
            const subFinanceAmount = Number(this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].subordinateFinancingAmount);

            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].ltv = Math.ceil(dcAmount / appraisedValue * 100);
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].tltv = Math.ceil(parseFloat(((dcAmount + subFinanceAmount) / appraisedValue * 100).toFixed(13)));

        }
        else {
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].ltv = 0;
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].tltv = 0;
        }
    }

    syncCoBorrowersToBestEffortsData() {
        if (!this.bestEffortsDeliveryData?.bestEffortsDeliveryData?.[0]) return;
        this.coBorrowers.forEach((cb, idx) => {
            const i = idx + 1;
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0][`coBorrower${i}FirstName`] = cb.firstName ?? null;
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0][`coBorrower${i}MiddleInitial`] = cb.middleInitial ?? null;
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0][`coBorrower${i}LastName`] = cb.lastName ?? null;
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0][`coBorrower${i}SSN`] = cb.ssn ?? null;
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0][`coBorrower${i}Suffix`] = cb.suffix ?? null;
        });
    }


    triggerRepriceModalOnSaveorSubmit() {
        const origSubProduct = this.originalDeliveryCommitment.subProductCode;
        const origNoteRate = this.originalDeliveryCommitment.noteRate;
        const selectedSubProductCode = this.dcExistingModel.deliveryCommitment.subProductCode;
        const selectedNoteRate = this.dcExistingModel.deliveryCommitment.noteRate;
        const selectedRemittanceType = this.dcExistingModel.deliveryCommitment.remittanceType;
        const selectedCommitmentTerm = this.originalDeliveryCommitment.commitmentTerm;

        let noteRateFound = false;


        if (this.pricingForDcApiResponse?.schedules) {
            for (const schedule of this.pricingForDcApiResponse.schedules) {
                for (const detail of schedule.scheduleDetail) {
                    if (
                        detail.subProductCode === selectedSubProductCode &&
                        detail.remittanceType === selectedRemittanceType &&
                        detail.commitmentTerm && Array.isArray(detail.commitmentTerm) && detail.commitmentTerm.length > 0
                    ) {
                        for (const term of detail.commitmentTerm) {
                            if (
                                term.numberOfDays === selectedCommitmentTerm &&
                                term.noteRate && Array.isArray(term.noteRate) && term.noteRate.length > 0
                            ) {
                                if (term.noteRate.some(nr => nr.rate === selectedNoteRate)) {
                                    noteRateFound = true;
                                    break;
                                }
                            }
                        }
                    }
                    if (noteRateFound) break;
                }
                if (noteRateFound) break;
            }
        }
        if (!noteRateFound) {
            const formattedValue = (selectedNoteRate * 100).toFixed(3) + '%';
            this.toastr.show([`The following Note Rate ${formattedValue} is invalid or cannot be found.`]);
            return;
        }

        const subProductChanged = origSubProduct !== selectedSubProductCode;
        const noteRateChanged = origNoteRate !== selectedNoteRate;

        if (subProductChanged || noteRateChanged) {
            // Set agent fee rates before opening modal
            this.originalAgentFeeRate = this.originalDeliveryCommitment.agentFee ?? 0;
            this.newAgentFeeRate = this.getAgentFeeForCurrentSelection() ?? 0;

            this.dcExistingModel.deliveryCommitment.noteRates = this.noteRates; // Update noteRates in the model
            this.dcExistingModel.deliveryCommitment.agentFee = this.getAgentFeeForCurrentSelection();
            
            this.openRepriceModal();
        }
        else {
            this.dcExistingModel.deliveryCommitment.noteRates = this.noteRates; // Update noteRates in the model
            this.dcExistingModel.deliveryCommitment.agentFee = this.getAgentFeeForCurrentSelection();
            // Emit the event to notify the parent component
                this.submitTradBEDC.emit({
                    repriceChanged: false,
                    dc: this.dcExistingModel.deliveryCommitment,
                    be: this.bestEffortsDeliveryData.bestEffortsDeliveryData[0]
                });
        }
    }


    submitEditDc() {
        this.formSubmitted = true;
        this.toastr.remove();
        if (this.besteffortsform.invalid) {
            return;
        }
        this.bestEffortsValidated = true;
        // Sync coBorrowers to main data object
        this.syncCoBorrowersToBestEffortsData();
        console.log('Synced BE Data:', this.bestEffortsDeliveryData.bestEffortsDeliveryData[0]);

        this.triggerRepriceModalOnSaveorSubmit();


    }


    cancelDC() {
        this.cancelTradBEDC.emit();
    }

    onPropertyAddressInput(event: any, directive: any): void {
        if (directive && directive.getSuggestions) {
            directive.getSuggestions(event.target.value);
        }
    }

    onAddressSelected(address: Address): void {
        if (!address) {
            return;
        }
        
        // Update property address fields
        const addressWithoutStateCityZip = address.formattedAddress.slice(0, -(address.areaName1 + address.areaName3 + address.postCode).length - 5);
        this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].propertyAddress = addressWithoutStateCityZip.trim();
        this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].propertyCity = address.areaName3;
        this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].propertyZipCode = address.postCode;

        // Find and set the state from the available states list
        const selectedState = this.stateOptions.find(
            (state) => state.value.toUpperCase() === (address.areaName1 || '').toUpperCase()
        );

        if (selectedState) {
            this.bestEffortsDeliveryData.bestEffortsDeliveryData[0].propertyState = selectedState.value;
        }
    }
}
